module.exports = __webpack_public_path__ + "static/media/portfolio3.7d19fa54.jpg";